import { Message } from 'element-ui'
import i18n from '@/lang'

export const beforeUpload = (file: any) => {
  const isLt = file.size / 1024 > 500 // KB
  if (isLt) {
    Message.warning(
      `${i18n.t('playTurbo.promoteManagement.promote.table.upload.rules', {
        fileSize: '500KB',
      })}`,
    )
  }
  return !isLt
}

export const productNameValidator = (rule: any, value: any, callback: any) => {
  // const re = /^[0-9a-zA-Z_]{1,50}$/
  if (value.length <= 50) {
    callback()
  } else {
    callback(new Error('Name must be between 1 and 50 characters'))
  }
}
